import { render, staticRenderFns } from "./CollectionUpdate.vue?vue&type=template&id=3da4bf44&scoped=true&"
import script from "./CollectionUpdate.vue?vue&type=script&lang=js&"
export * from "./CollectionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4bf44",
  null
  
)

export default component.exports